import gql from 'graphql-tag'

export const QUERY_MERCAPROMO_METRICS = gql`
  query MercapromoMetrics {
    mercapromoMetrics {
      type
      coupons {
        with_products
        with_eligible_quantity
        with_earn
      }
      sold_units {
        total
        total_in_offer
      }
      clients {
        uniques_in_offer
      }
      discounts {
        total
      }
      created_at
    }
  }
`
export const QUERY_SUGGESTED_PRODUCTS_OPPORTUNITIES = gql`
  query SuggestedProductsOpportunities($units: [String]) {
    suggestedProductsOpportunities(units: $units) {
      revenuePercentage
      clientsPercentage
      potentialRevenue
      basketItemsPercentage
      products
    }
  }
`

export const QUERY_GET_HOME_CONSUMERS_DISTRIBUTION = gql`
  query ClientsActivityClusters($date: String!, $segments: [ID]) {
    clientsActivityClusters(date: $date, segments: $segments) {
      actives {
        quantity
        percentage
      }
      recentInactives {
        quantity
        percentage
      }
      atRisk {
        quantity
        percentage
      }
      losses {
        quantity
        percentage
      }
      neverBought {
        quantity
        percentage
      }
    }
  }
`
